import { render, staticRenderFns } from "./Vacation.vue?vue&type=template&id=45e16aec&scoped=true&"
var script = {}
import style0 from "./Vacation.vue?vue&type=style&index=0&id=45e16aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e16aec",
  null
  
)

export default component.exports